// /TBS/frontend/src/Pages/Admin/components/Navbar.jsx
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { LogoutNavbarLink } from "../../Logout/LogoutNavbar";
import { useAuth } from "../../../Context/AuthContext";
import LogoSvg from "../assets/images/ThinkBeyond_Logo.png";
import LogoSvgMini from "../assets/images/ThinkBeyond-Mini-Logo.png";

const Navbar = ({ toggleMinimize, toggleMobileSidebar, jobsCount }) => {
  const [auth] = useAuth();
  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
  const [messageDropdownOpen, setMessageDropdownOpen] = useState(false);

  const toggleProfileDropdown = () => {
    setProfileDropdownOpen(!profileDropdownOpen);
    if (messageDropdownOpen) setMessageDropdownOpen(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (!event.target.closest(".dropdown")) {
        setProfileDropdownOpen(false);
        setMessageDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Prefer the prop (fresh count from parent page); fall back to auth context.
  const postedJobsCount =
    typeof jobsCount === "number"
      ? jobsCount
      : Array.isArray(auth?.user?.jobsPostedBy)
        ? auth.user.jobsPostedBy.length
        : 0;

  return (
    <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
      <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
        <Link className="navbar-brand brand-logo" to="/">
          <img src={LogoSvg} alt="logo" />
        </Link>
        <a className="navbar-brand brand-logo-mini" href="index.html">
          <img src={LogoSvgMini} alt="logo" />
        </a>
      </div>

      <div className="navbar-menu-wrapper d-flex align-items-stretch">
        <button
          className="navbar-toggler navbar-toggler align-self-center"
          type="button"
          data-toggle="minimize"
          onClick={toggleMinimize}
        >
          <span className="mdi mdi-menu"></span>
        </button>

        <div className="search-field d-none d-md-block">
          <form className="d-flex align-items-center h-100" action="#">
            <div className="input-group">
              <div className="input-group-prepend bg-transparent">
                <i className="input-group-text border-0 mdi mdi-magnify"></i>
              </div>
              <input
                type="text"
                className="form-control bg-transparent border-0"
                placeholder="Search projects"
              />
            </div>
          </form>
        </div>

        <ul className="navbar-nav navbar-nav-right">
          {/* 👇 Posted Jobs — now points to the public Search-Jobs page */}
          <li className="nav-item d-none d-lg-flex align-items-center">
            <Link
              className="nav-link d-flex align-items-center"
              to="/Search-Jobs"
              title="View posted jobs on the public jobs page"
            >
              <i className="mdi mdi-briefcase me-1"></i>
              <b>Posted Jobs</b>
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minWidth: 24,
                  height: 22,
                  padding: "0 8px",
                  marginLeft: 8,
                  borderRadius: 11,
                  background: "#0077b6",
                  color: "#ffffff",
                  fontSize: 11.5,
                  fontWeight: 700,
                  letterSpacing: "0.2px",
                  boxShadow: "0 2px 6px rgba(0, 119, 182, 0.25)"
                }}
              >
                {postedJobsCount > 99 ? "99+" : postedJobsCount}
              </span>
            </Link>
          </li>

          <li className="nav-item nav-profile dropdown">
            <a
              className={`nav-link dropdown-toggle ${
                profileDropdownOpen ? "show" : ""
              }`}
              id="profileDropdown"
              href="#"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              onClick={(e) => {
                e.preventDefault();
                toggleProfileDropdown();
              }}
            >
              <div className="nav-profile-img">
                <img src={LogoSvgMini} alt="Profile" />
                <span className="availability-status online"></span>
              </div>
              <div className="nav-profile-text">
                <p className="mb-1 text-black">Admin Actions</p>
              </div>
            </a>
            <div
              className={`dropdown-menu navbar-dropdown ${
                profileDropdownOpen ? "show" : ""
              }`}
              aria-labelledby="profileDropdown"
            >
              <Link className="dropdown-item" to="/Admin/Dashboard">
                <i className="mdi mdi-home me-2 text-success"></i> Dashboard
              </Link>
              <div className="dropdown-divider"></div>

              {/* 👇 Also points to the public Search-Jobs page */}
              <Link className="dropdown-item" to="/Search-Jobs">
                <i className="mdi mdi-briefcase me-2 text-success"></i> Posted
                Jobs
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: 20,
                    height: 18,
                    padding: "0 6px",
                    marginLeft: "auto",
                    borderRadius: 9,
                    background: "#e0f2fe",
                    color: "#0077b6",
                    fontSize: 11,
                    fontWeight: 700
                  }}
                >
                  {postedJobsCount}
                </span>
              </Link>
              <div className="dropdown-divider"></div>

              <Link className="dropdown-item" to="/Admin/TBS-Add-Job">
                <i className="mdi mdi-plus-circle me-2 text-success"></i> Add
                New Job
              </Link>
              <div className="dropdown-divider"></div>

              <Link className="dropdown-item" to="/Admin/Manage-Test-Sectors">
                <i className="mdi mdi-format-list-bulleted-type me-2 text-success"></i>{" "}
                Job Sectors
              </Link>
              <div className="dropdown-divider"></div>

              <LogoutNavbarLink className="dropdown-item">
                <i className="mdi mdi-logout me-2 text-success"></i>
                Logout
              </LogoutNavbarLink>
            </div>
          </li>

          <li className="nav-item dropdown">
            <Link
              className="nav-link count-indicator dropdown-toggle"
              id="messageDropdown"
              to="#"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <b>Links</b>
            </Link>
            <div
              className="dropdown-menu dropdown-menu-end navbar-dropdown preview-list"
              aria-labelledby="messageDropdown"
            >
              <h6 className="p-3 mb-0">Page Links</h6>
              <div className="dropdown-divider"></div>
              <Link className="dropdown-item preview-item" to="/">
                <i className="mdi mdi-home me-2"></i>
                <div className="preview-item-content d-flex align-items-start flex-column justify-content-center">
                  <h6 className="preview-subject ellipsis mb-1 font-weight-normal">
                    Home
                  </h6>
                </div>
              </Link>
              <div className="dropdown-divider"></div>
              <Link className="dropdown-item preview-item" to="/Search-Jobs">
                <i className="mdi mdi-briefcase me-2"></i>
                <div className="preview-item-content d-flex align-items-start flex-column justify-content-center">
                  <h6 className="preview-subject ellipsis mb-1 font-weight-normal">
                    Search Jobs
                  </h6>
                </div>
              </Link>
              <div className="dropdown-divider"></div>
              <Link className="dropdown-item preview-item" to="/About-Us">
                <i className="mdi mdi-theater me-2"></i>
                <div className="preview-item-content d-flex align-items-start flex-column justify-content-center">
                  <h6 className="preview-subject ellipsis mb-1 font-weight-normal">
                    About Us
                  </h6>
                </div>
              </Link>
              <div className="dropdown-divider"></div>
              <Link className="dropdown-item preview-item" to="/Who-We-Are">
                <i className="mdi mdi-server me-2"></i>
                <div className="preview-item-content d-flex align-items-start flex-column justify-content-center">
                  <h6 className="preview-subject ellipsis mb-1 font-weight-normal">
                    Who We Are
                  </h6>
                </div>
              </Link>
            </div>
          </li>
        </ul>

        <button
          className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
          type="button"
          data-toggle="offcanvas"
          onClick={toggleMobileSidebar}
        >
          <span className="mdi mdi-menu"></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
